import { Avatar as NoPhoto, Image } from '@cian/ui-kit';

import * as styles from './Avatar.css';
import { IAgentCard } from '../../types/agentCard';

interface IAvatarProps {
  avatarUrl: IAgentCard['avatarUrl'];
}

export const Avatar = ({ avatarUrl }: IAvatarProps) => {
  return (
    <div className={styles['avatar']}>
      {avatarUrl ? (
        <Image src={avatarUrl} width={120} borderRadius={'4px'} objectFit="contain" />
      ) : (
        <NoPhoto size={120} type={'agency'} />
      )}
    </div>
  );
};
